import { Tooltip, TooltipContent ,TooltipTrigger } from "../ui/tooltip";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

type ColorButtonWithTooltipProps = {
  name: string;
  colorCode: string;
  handleColorClick: () => void;
  isSelected: boolean;
};

const ColorButtonWithTooltip = ({
  name,
  colorCode,
  handleColorClick,
  isSelected,
}: ColorButtonWithTooltipProps) => {
  return (
    <Tooltip key={name}>
      <TooltipContent>{name}</TooltipContent>
      <TooltipTrigger asChild>
        <Button
          key={colorCode}
          aria-pressed={isSelected}
          className={cn(
            "w-5 h-5 p-0 rounded-full border ring-0 ring-offset-3 ring-offset-background cursor-pointer ml-2 mr-2",
            "hover:ring-1 hover:ring-gray-500",
            isSelected && "ring-1 ring-peak-granite"
          )}
          style={{ backgroundColor: colorCode }}
          onClick={handleColorClick}
        />
          </TooltipTrigger>
        </Tooltip>
  );
};

export default ColorButtonWithTooltip;